<div class="d-flex flex-wrap" style="flex-direction: column">
  <div style="height: 65px; position: sticky; top: 0px; background-color: #fff">
    <div class="reg-search-container">
      <div class="reg-search-input">
        <div style="padding-left: 8px; padding-right: 8px">
          <div class="md-inputfield" style="position: relative">
            <input
              id="regInput"
              #regInput
              autofocus
              (ngModelChange)="searchTextChanged($event)"
              [ngModel]="searchText"
              autocomplete="off"
              class="search-box"
              name="regInput"
              pInputText
              placeholder="Search Vehicle Reg."
              spellcheck="false"
              type="text"
              style="width: 100%"
            />
            <span class="fa fa-search search-icon"></span>
          </div>
        </div>
      </div>
      <div class="busy-spinner" *ngIf="isBusy">
        <i class="fa fa-2x fa-spin fa-spinner"></i>
      </div>
    </div>
  </div>

  <div style="color: rgb(51, 51, 51); flex-grow: 1; overflow-y: auto; max-height: 400px">
    <div class="px-2">
      <table class="organisation-view" style="width: 100%; font-size: 0.8rem">
        <thead>
          <tr>
            <th style="text-align: left">Vehicle Reg.</th>
            <th style="text-align: left">Job #</th>
            <th style="text-align: center">Status</th>
            <th style="text-align: left">Customer</th>
            <th style="text-align: left">Supplier</th>
          </tr>
        </thead>
        <tbody>
          <tr
            (click)="jobSelected(job, i)"
            *ngFor="let job of jobInfos; let i = index"
            [ngClass]="{ 'selected-row': selectedRow === i }"
          >
            <td style="text-align: left">
              <div class="vehicle-reg">{{ job.vehicleReg }}</div>
            </td>
            <td>
              <div style="font-size: 14px; font-weight: 700">
                <a href="/app/jobscreen/{{ job.jobId }}" target="_blank">{{ job.jobNumber }}</a>
              </div>
            </td>
            <td>
              <div class="job-status">{{ job.jobStatus }}</div>
            </td>
            <td class="hover-item org-name" (click)="organisationSelected(job, true)">
              {{ job.customer.name }}
            </td>
            <td
              [ngClass]="{ 'hover-item': job.supplier }"
              class="org-name"
              (click)="organisationSelected(job, false)"
            >
              {{ job.supplier?.name }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
